import { render, staticRenderFns } from "./sendEmailcode.vue?vue&type=template&id=518af235&scoped=true"
import script from "./sendEmailcode.vue?vue&type=script&lang=js"
export * from "./sendEmailcode.vue?vue&type=script&lang=js"
import style0 from "./sendEmailcode.vue?vue&type=style&index=0&id=518af235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518af235",
  null
  
)

export default component.exports